/**
 * RevenueManagement
 * 
 * Description: This component serves as a container for various revenue-related 
 * statistics and graphs. It imports and displays components such as 
 * RevenueStatistics, EarningsGraph, PlatformRevenueGraph, ConsultationRevenue, 
 * and in a responsive layout.
 * 
 * File Name: RevenueManagement.tsx
 * Date: 01-10-2024
 * Updated Date: 05-02-2025
 */

import React from 'react';
import OverAllStatsGraph from 'src/Components/AdminComponents/Graphs/OverAllStatsGraph';
import RevenuePercentages from 'src/Components/AdminComponents/Graphs/RevenuePercentages';
import RevenueStatistics from 'src/Components/AdminComponents/RevenueStatistics';

const RevenueManagement: React.FC = () => {
    return (
        <div className="gap-marging-admin">
            <RevenueStatistics />
            <div className="parent-box">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <OverAllStatsGraph
                        title="Earning"
                        type="BarChart"
                    />
                    <OverAllStatsGraph
                        title="Revenue"
                        type="LineChart"
                    />
                    <RevenuePercentages />
                </div>
            </div>
        </div>
    );
};

export default RevenueManagement;